import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import BLCheckbox from "../../utils/components/BLCheckbox";
import BLInput from "../../utils/components/BLInput";
import BLLoader from "../../utils/components/BLLoader";
import { currencyFormatter } from "../../utils/helper";
import { PACKAGE_TYPES } from "../../utils/db/packageTypes";

const Sidebar = (props) => {
  const [promotionCode, setPromotionCode] = useState("");

  useEffect(() => {
    if (props.promoCodeApplied && props.promoCodeApplied.code !== promotionCode)
      setPromotionCode(props.promoCodeApplied.code);
    else if (!props.promoCodeApplied) setPromotionCode("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.promoCodeApplied]);

  const discountPrice = parseFloat(props.discountPrice);
  let cartTotal = parseFloat(props.cartTotal);

  cartTotal -= props.promoPrice;

  let grandTotal =
    Math.round(parseFloat(discountPrice) * 100) / 100 <=
    Math.round(parseFloat(cartTotal) * 100) / 100
      ? parseFloat(cartTotal - discountPrice).toFixed(2)
      : 0;

  return (
    <div className="sidebar-holder">
      <div className="sidebar mb-4">
        <div className="row">
          <div className="col">
            <h6 className="title">
              {props.translate("payment.sidebar.title")}
            </h6>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="area-holder">
              <div className="row">
                <div className="col text-left">
                  <span className="area-title d-inline-block">
                    {props.translate("payment.sidebar.general_total")}:
                  </span>
                </div>
                <div className="col text-right">
                  <span className="area-content d-inline-block">
                    {currencyFormatter(
                      props.currency,
                      props.cartTotal,
                      props.lang
                    )}
                  </span>
                </div>
              </div>

              {props.promoCodeApplied && (
                <div className="row">
                  <div className="col text-left">
                    <span className="area-title d-inline-block">
                      {props.translate("payment.sidebar.promo_discount")}:
                    </span>
                  </div>
                  <div className="col text-right">
                    <span className="area-content gift-card-fix d-inline-block">
                      -{" "}
                      {props.promoCodeApplied.is_percentage
                        ? `%${parseInt(
                            parseFloat(props.promoCodeApplied.amount) * 100
                          )}`
                        : currencyFormatter(
                            props.promoCodeApplied.currency,
                            parseFloat(props.promoCodeApplied.amount),
                            props.lang
                          )}
                    </span>
                  </div>
                </div>
              )}

              {Boolean(props.discountPrice) && (
                <div className="row">
                  <div className="col text-left">
                    <span className="area-title d-inline-block">
                      {props.translate("payment.sidebar.gift_card")}:
                    </span>
                  </div>
                  <div className="col text-right">
                    <span className="area-content gift-card-fix d-inline-block">
                      -{" "}
                      {currencyFormatter(
                        props.currency,
                        discountPrice,
                        props.lang
                      )}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="total-area-holder">
              <div className="row">
                <div className="col text-left d-flex align-items-end">
                  <span className="area-title">
                    {props.translate("payment.sidebar.amount_to_be_paid")}:
                  </span>
                </div>
                <div className="col text-right">
                  <span className="area-content">
                    {currencyFormatter(
                      props.currency,
                      props.newTotal ? props.newTotal : grandTotal,
                      props.lang
                    )}
                  </span>
                </div>
              </div>
              {String(props.newTotal) !== String(grandTotal) &&
                Boolean(props.newTotal) && (
                  <div className="row interest-row">
                    <div className="col text-left d-flex align-items-end">
                      <span className="area-title">
                        {props.translate("payment.sidebar.interest_amount")}:
                      </span>
                    </div>
                    <div className="col text-right">
                      <span className="area-content">
                        {currencyFormatter(
                          props.currency,
                          (parseFloat(props.newTotal) - grandTotal).toFixed(2),
                          props.lang
                        )}
                      </span>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      {props.cart.items[0].package_type !== PACKAGE_TYPES.GIFTCARD ? (
        <div className="sidebar promo-code-area position-relative mb-4">
          <div className="row">
            <div className="col">
              <h6 className="title">
                {props.translate("global.promotion_code")}
              </h6>
            </div>
          </div>
          <div className="row">
            <div className="col position-relative">
              <BLInput
                type="text"
                label={props.translate("global.promotion_code")}
                name="promotion_code"
                value={promotionCode}
                changed={({ target }) =>
                  setPromotionCode(target.value.toUpperCase())
                }
                maxLength={10}
                inputProps={{ readOnly: Boolean(props.promoCodeApplied) }}
                classes="promo-code-input m-0"
              />
              <div
                className="apply-button text-uppercase position-absolute d-flex align-items-center justify-content-end"
                data-is-applied={props.promoCodeApplied ? "true" : "false"}
                onClick={() =>
                  props.handleApplyPromoCode(
                    props.promoCodeApplied ? null : promotionCode
                  )
                }
              >
                {props.translate(
                  `global.${props.promoCodeApplied ? `applied` : `apply`}`
                )}

                {props.promoCodeApplied && (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.96 0C3.12748 0 0 3.01964 0 6.72C0 10.4204 3.12748 13.44 6.96 13.44C10.7925 13.44 13.92 10.4204 13.92 6.72C13.92 3.01964 10.7925 0 6.96 0Z"
                      fill="#8E8E8E"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.82344 4.16719C9.66598 4.00973 9.41069 4.00973 9.25323 4.16719L7 6.42041L4.74677 4.16719C4.58931 4.00973 4.33402 4.00973 4.17656 4.16719L4.16658 4.17717C4.00912 4.33463 4.00912 4.58992 4.16658 4.74738L6.41981 7.0006L4.16658 9.25383C4.00912 9.41129 4.00912 9.66658 4.16658 9.82404L4.17656 9.83402C4.33402 9.99148 4.58931 9.99148 4.74677 9.83402L7 7.58079L9.25323 9.83402C9.41069 9.99148 9.66598 9.99148 9.82344 9.83402L9.83342 9.82404C9.99088 9.66658 9.99088 9.41129 9.83342 9.25383L7.58019 7.0006L9.83342 4.74738C9.99088 4.58992 9.99088 4.33463 9.83342 4.17717L9.82344 4.16719Z"
                      fill="white"
                    />
                    <path
                      d="M9.82344 4.16719L9.64666 4.34396L9.82344 4.16719ZM7 6.42041L6.82322 6.59719L7 6.77397L7.17678 6.59719L7 6.42041ZM4.74677 4.16719L4.57 4.34396L4.74677 4.16719ZM6.41981 7.0006L6.59659 7.17738L6.77336 7.0006L6.59659 6.82383L6.41981 7.0006ZM4.16658 9.82404L3.98981 10.0008L4.16658 9.82404ZM4.17656 9.83402L4.35334 9.65724L4.17656 9.83402ZM7 7.58079L7.17678 7.40402L7 7.22724L6.82322 7.40402L7 7.58079ZM7.58019 7.0006L7.40341 6.82383L7.22664 7.0006L7.40341 7.17738L7.58019 7.0006ZM9.83342 4.17717L10.0102 4.00039L9.83342 4.17717ZM9.43 4.34396C9.48983 4.28414 9.58683 4.28414 9.64666 4.34396L10.0002 3.99041C9.74512 3.73532 9.33154 3.73532 9.07645 3.99041L9.43 4.34396ZM7.17678 6.59719L9.43 4.34396L9.07645 3.99041L6.82322 6.24364L7.17678 6.59719ZM4.57 4.34396L6.82322 6.59719L7.17678 6.24364L4.92355 3.99041L4.57 4.34396ZM4.35334 4.34396C4.41317 4.28414 4.51017 4.28414 4.57 4.34396L4.92355 3.99041C4.66846 3.73532 4.25488 3.73532 3.99979 3.99041L4.35334 4.34396ZM4.34336 4.35394L4.35334 4.34396L3.99979 3.99041L3.98981 4.00039L4.34336 4.35394ZM4.34336 4.5706C4.28353 4.51077 4.28353 4.41377 4.34336 4.35394L3.98981 4.00039C3.73472 4.25548 3.73472 4.66906 3.98981 4.92415L4.34336 4.5706ZM6.59659 6.82383L4.34336 4.5706L3.98981 4.92415L6.24303 7.17738L6.59659 6.82383ZM4.34336 9.43061L6.59659 7.17738L6.24303 6.82383L3.98981 9.07705L4.34336 9.43061ZM4.34336 9.64726C4.28353 9.58744 4.28353 9.49044 4.34336 9.43061L3.98981 9.07705C3.73472 9.33214 3.73472 9.74573 3.98981 10.0008L4.34336 9.64726ZM4.35334 9.65724L4.34336 9.64726L3.98981 10.0008L3.99979 10.0108L4.35334 9.65724ZM4.57 9.65724C4.51017 9.71707 4.41317 9.71707 4.35334 9.65724L3.99979 10.0108C4.25488 10.2659 4.66846 10.2659 4.92355 10.0108L4.57 9.65724ZM6.82322 7.40402L4.57 9.65724L4.92355 10.0108L7.17678 7.75757L6.82322 7.40402ZM9.43 9.65724L7.17678 7.40402L6.82322 7.75757L9.07645 10.0108L9.43 9.65724ZM9.64666 9.65724C9.58683 9.71707 9.48983 9.71707 9.43 9.65724L9.07645 10.0108C9.33154 10.2659 9.74512 10.2659 10.0002 10.0108L9.64666 9.65724ZM9.65664 9.64726L9.64666 9.65724L10.0002 10.0108L10.0102 10.0008L9.65664 9.64726ZM9.65664 9.43061C9.71647 9.49044 9.71647 9.58744 9.65664 9.64726L10.0102 10.0008C10.2653 9.74573 10.2653 9.33214 10.0102 9.07705L9.65664 9.43061ZM7.40341 7.17738L9.65664 9.43061L10.0102 9.07705L7.75697 6.82383L7.40341 7.17738ZM9.65664 4.5706L7.40341 6.82383L7.75697 7.17738L10.0102 4.92415L9.65664 4.5706ZM9.65664 4.35394C9.71647 4.41377 9.71647 4.51077 9.65664 4.5706L10.0102 4.92415C10.2653 4.66906 10.2653 4.25548 10.0102 4.00039L9.65664 4.35394ZM9.64666 4.34396L9.65664 4.35394L10.0102 4.00039L10.0002 3.99041L9.64666 4.34396Z"
                      fill="white"
                    />
                  </svg>
                )}
              </div>
            </div>
          </div>
          {props.promoCodeApplied && (
            <h6 className="promo-title position-absolute m-0">
              &bull; {props.promoCodeApplied.title}
            </h6>
          )}
        </div>
      ) : (
        ``
      )}
      <div
        className={`end d-none d-lg-flex flex-column justify-content-between ${
          props.payingError ? `align-items-start` : `align-items-center`
        }`}
      >
        <div className="disclaimer mb-3">
          <BLCheckbox
            label={props.translate(
              "payment.pick_a_payment_method.dsc_and_pif",
              {
                dscLink: (
                  <Link to="#!" onClick={props.handleShowSaleAgreementModal}>
                    {props.translate("global.dsc")}
                  </Link>
                ),
                pifLink: (
                  <Link to="#!" onClick={props.handleShowPreInfoAgreementModal}>
                    {props.translate("global.pif")}
                  </Link>
                ),
              }
            )}
            name="agreement"
            changed={props.handleSetAgreements}
            checked={props.agreementsAgreed}
            id="agreementsSidebar"
          />
        </div>
        {props.isPaying ? (
          <BLLoader />
        ) : (
          <div className="d-flex justify-content-end w-100">
            <button
              className="pay-now-button position-relative w-100"
              onClick={props.handlePay}
              disabled={!props.isOkayToPay}
            >
              {Math.round(parseFloat(props.cartTotal) * 100) / 100 >
              Math.round(parseFloat(props.discountPrice) * 100) / 100
                ? props.translate("payment.pick_a_payment_method.pay_now")
                : props.translate(
                    "payment.pick_a_payment_method.complete_process"
                  )}
              {!props.isOkayToPay && (
                <span className="disabled-tooltip bottom position-absolute w-100">
                  {props.translate(
                    "payment.pick_a_payment_method.button_disabled_tooltip"
                  )}
                </span>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
